module.exports = __webpack_public_path__ + "static/media/map.85147865.png";